import { render, staticRenderFns } from "./StaffForm.vue?vue&type=template&id=f30f45f0&scoped=true&"
import script from "./StaffForm.vue?vue&type=script&lang=js&"
export * from "./StaffForm.vue?vue&type=script&lang=js&"
import style0 from "./StaffForm.vue?vue&type=style&index=0&id=f30f45f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30f45f0",
  null
  
)

export default component.exports